import { useLocation } from 'react-router'

export function useQueryParam<T extends string>(param: string) {
  const { search } = useLocation()
  const queryParams = new URLSearchParams(search)
  return queryParams.get(param) as T | null
}
